import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { User } from '../_models';
import { MainServiceService } from '../services/main-service.service';

@Injectable({ providedIn: 'root' })
export class AccountService {
    private userSubject: BehaviorSubject<User>;
    public user: Observable<User>;

    constructor(
        private router: Router,
        private http: HttpClient,
        private masterService: MainServiceService,
        
    ) {
        this.userSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('user')));
        this.user = this.userSubject.asObservable();
    }
    
    public get userValue(): User {
        return this.userSubject.value;
    }

    login(username, password) {
        return this.http.post <any>(`${environment.apiUrl}/api/jwt`,{ username, password}) //for central
        // return this.http.post <any>(`${environment.apiUrl}/api/franchisejwt`,{ username, password}) //for franchise
            .pipe(map(user => {
                console.log("@user response",user)
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('user', JSON.stringify(user.userInfo));
                localStorage.setItem('TOKEN',JSON.stringify(user.token));
                localStorage.setItem('dashboardSettings', JSON.stringify(user.setting));
                
                this.userSubject.next(user);
                return user;
            }));
    }
//     login(username, password){
//   this.http.post<User>(`${environment.apiUrl}/jwt`, { username, password})
//   .subscribe(data=>
//     {
// console.log("Data",data)
//     })
     

    logout() {
        // remove user from local storage and set current user to null
        localStorage.removeItem('user');
        localStorage.removeItem('TOKEN');
        this.userSubject.next(null);
        this.router.navigate(['/account/login']);
        
    }

    register(user: User) {
        return this.http.post(`${environment.apiUrl}/users/register`, user);
    }

    getAll() {
        return this.http.get<User[]>(`${environment.apiUrl}/users`);
    }

    getById(id: string) {
        return this.http.get<User>(`${environment.apiUrl}/users/${id}`);
    }

    update(id, params) {
        return this.http.put(`${environment.apiUrl}/users/${id}`, params)
            .pipe(map(x => {
                // update stored user if the logged in user updated their own record
                if (id == this.userValue.id) {
                    // update local storage
                    const user = { ...this.userValue, ...params };
                    localStorage.setItem('user', JSON.stringify(user));

                    // publish updated user to subscribers
                    this.userSubject.next(user);
                }
                return x;
            }));
    }

    delete(id: string) {
        return this.http.delete(`${environment.apiUrl}/users/${id}`)
            .pipe(map(x => {
                // auto logout if the logged in user deleted their own record
                if (id == this.userValue.id) {
                    this.logout();
                }
                return x;
            }));
    }
}